<template>
  <div class="order-forQy">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="客户信息" name="first">
          <el-scrollbar>
            <div style="width: 100%">
              <el-col :span="8">
                <el-form-item label="订单编号">
                  <el-input v-model="form.fBillNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经销商名称">
                  <el-input :value="form.fDistributor" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户">
                  <el-input :value="form.fCustomer" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户经营许可证">
                  <el-input :value="form.fBusinessNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户经营地址">
                  <el-input :value="form.fAddress_jy" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票名称">
                  <el-input :value="form.fBillingName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货人">
                  <el-input :value="form.fName_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话">
                  <el-input :value="form.fPhone" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货地址">
                  <el-input :value="form.fAddress_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运费付款方式">
                  <el-input :value="form.fPayType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="仓库">
                  <el-input :value="form.fStock" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发货方式">
                  <el-input :value="form.fDeliverType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="交货日期">
                  <el-input :value="form.fDate" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="付款比例(%)">
                  <el-input :value="form.fDeductionRatio" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注">
                  <el-input
                    v-model="form.fDes"
                    disabled
                    type="textarea"
                    :rows="4"
                  />
                </el-form-item>
              </el-col>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="订单信息" name="second">
          <el-table :data="form.entrys" height="100%">
            <el-table-column label="产品编号" prop="fNumber" />
            <el-table-column label="产品名称" prop="fName" />
            <el-table-column label="规格" prop="fModel" />
            <el-table-column label="单位" prop="fUnit" />
            <el-table-column label="数量" prop="fQty" />
            <el-table-column label="小计" prop="total" />
            <el-table-column label="备注" prop="fDes" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="canAudit" name="four" label="确认">
          <el-form
            ref="form"
            v-loading="loading"
            :model="form"
            :rules="rules"
            label-width="78px"
            style="overflow: auto"
          >
            <el-form-item
              label="审批意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <el-button
            v-if="canAudit"
            type="primary"
            :disabled="saving"
            style="margin-left: 78px"
            @click="submit(1)"
          >通过</el-button>
          <el-button
            v-if="canAudit"
            type="warning"
            :disabled="saving"
            style=""
            @click="submit(2)"
          >回退</el-button>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  inject: ['getMap'],
  data: function() {
    return {
      form: {
        procedureInfo: {},
        entrys: []
      },

      rules: {},

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canAudit: function() {
      // console.log(this.form, "this.form");

      if (this.form) {
        if (this.form.readOnly == false) {
          return true
        }
      }
      return false
    }
  },
  mounted() {},
  methods: {
    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.form.procedureInfo.fType = type
          if (type == 2) {
            if (!this.form.procedureInfo.fOpinion) {
              this.$message.error('请填写审核意见')
              return
            }
            this.form.procedureInfo.returnNode = 1
          } else {
            this.form.procedureInfo.returnNode = null
          }

          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.$httpPost('OrderManage/OrderForQy/OrderForQyApproval', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist)

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/orderForQy' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost('OrderManage/OrderForQy/GetOrderForQy', {
        fid: id
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      const date = res.datalist.fDate
      if (date == undefined || date == null) {
        this.form.fDate = ''
      }
      this.form.fDate = moment(date).format('YYYY-MM-DD')
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == null) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.order-forQy {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;
    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 150px);
      .el-tab-pane {
        height: calc(100vh - 150px);
      }
    }
  }
}
</style>
